import { render } from "./ErrorModal.vue?vue&type=template&id=1565f77d"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"

import "./ErrorModal.vue?vue&type=style&index=0&id=1565f77d&lang=css"

import exportComponent from "/app/vendor/quizwhiz-legacy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__